import ApiService from "./api.service";

export const GET_ALL_PARTNERS = "getAllPartners";
export const GET_PARTNERS = "getPartners";
export const POST_PARTNER = "postPartner";
export const DELETE_PARTNER = "deletePartner";
export const UPDATE_PARTNER = "updatePartner";

export const SET_ALL_PARTNERS = "setAllPartners";
export const SET_PARTNERS = "setPartners";

const state = {
  allPartners: [],
  partners: {}
}

const getters = {
  currentAllPartners(state) {
    return state.allPartners;
  },
  currentPartners(state) {
    return state.partners;
  }
}

const actions = {
  [GET_ALL_PARTNERS](context) {
    return new Promise((resolve, reject) => {
      ApiService.get("api/partners", { per_page: 100 })
        .then(async ({ data }) => {
          await context.commit(SET_ALL_PARTNERS, data.data.rows);
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  [GET_PARTNERS](context, params) {
    return new Promise((resolve, reject) => {
      Object.assign(params, { per_page: 10 })
      ApiService.get("api/partners", params)
        .then(async ({ data }) => {
          Object.assign(data.data, { page: params.page })
          await context.commit(SET_PARTNERS, data.data);
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  [POST_PARTNER](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post("api/partners", params.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  [DELETE_PARTNER](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.delete("api/partners/"+params)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  [UPDATE_PARTNER](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch("api/partners/"+params.id, params.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
}

const mutations = {
  [SET_ALL_PARTNERS](state, data) {
    state.allPartners = data;
    return;
  },
  [SET_PARTNERS](state, data) {
    
    // handle total page, and etc
    let limit = 10;
    const start = 1 + ((data.page - 1) * limit)
    const maxData = data.page * limit;
    let last_row = 0;
    if (data.count > maxData) {
      last_row = maxData;
    } else {
      last_row = (data.count % limit) + ((data.page - 1) * limit);
    }

    // handle pagination
    const total_page = Math.ceil(data.count / limit);
    let page_list = [];
    const diff = total_page - data.page;
    if (diff >= 5) {
      page_list = [data.page, data.page+1, "...", total_page-1, total_page];
    } else {
      if (total_page > 5) {
        for (let i=total_page-4; i<=total_page; i++) {
          page_list.push(i);
        }
      } else {
        for (let i=1; i<=total_page; i++) {
          page_list.push(i);
        }
      }
    }
    
    Object.assign(data, { start, last_row, page_list, total_page })

    state.partners = data;
    return;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
};
